import React from "react";
import Header from '../Home/Screens/Header';
import ContentFooter from '../Services/Screens/ContentFooter'
import ErrorPage from "./errorPage";



const ErrorHome = () => {

    return (
        <>
            <Header />
            <ErrorPage />
            <ContentFooter />
        </>
    )
}


export default ErrorHome